/**
 * @file report-sprint.tsx
 * @description Специализированная форма фильтрации для отчетов по спринтам в Task Manager приложении, которая обеспечивает фильтрацию данных спринтов по ключевым параметрам проекта. Включает предопределенный набор фильтров: задачи (task), состояние (state), исполнитель (executor) и дата (date), используя утилиту getFieldByName для генерации соответствующих полей формы с автоматической типизацией и валидацией.
 * @author AI-Generated | Human-Reviewed
 * @created 2025-01-15
 * @updated 2025-01-16
 * @dependencies ['@features/filter/helper']
 * @related-files ['src/features/filter/components/table-modal/table-modal.component.tsx', 'src/features/report/report.component.tsx', 'src/features/filter/helper.ts']
 */

import { getFieldByName } from '@features/filter/helper';

export const ReportSprint = ({ control, filters }: any) => {
    return (
        <div className="flex flex-col gap-default w-[25.405vmin]">
            {getFieldByName(filters, control, 'task')}
            {getFieldByName(filters, control, 'state')}
            {getFieldByName(filters, control, 'executor')}
            {getFieldByName(filters, control, 'date')}
        </div>
    );
};